import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { "data-qa": "field-label-text" }
const _hoisted_3 = { "data-qa": "field-required-icon" }
const _hoisted_4 = { "data-qa": "field-label-description" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gfu-field__label-wrapper", {
             'gfu-field__label-wrapper--inline': $props.inline,
         }])
  }, [
    _createElementVNode("label", {
      for: $options.effectiveFor,
      class: _normalizeClass(["gfu-field__label", {'gfu-field__label--columns-layout': $props.layout === 'columns', '_pen': $props.readOnly}])
    }, [
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString($props.text), 1 /* TEXT */)
        ])
      ]),
      _withDirectives(_createElementVNode("em", _hoisted_3, "*", 512 /* NEED_PATCH */), [
        [_vShow, $props.isRequired]
      ]),
      ($props.tooltipText || _ctx.$slots.tooltip)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 0,
            text: $props.tooltipText,
            class: "_ml-1"
          }, {
            content: _withCtx(() => [
              _renderSlot(_ctx.$slots, "tooltip")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                name: "circle-info",
                class: "_pea"
              })
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["text"]))
        : _createCommentVNode("v-if", true)
    ], 10 /* CLASS, PROPS */, _hoisted_1),
    ($props.description || _ctx.$slots.description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["gfu-field__description", {'gfu-field__description--columns-layout': $props.layout === 'columns'}])
        }, [
          _createElementVNode("span", _hoisted_4, [
            _renderSlot(_ctx.$slots, "description", {}, () => [
              _createTextVNode(_toDisplayString($props.description), 1 /* TEXT */)
            ])
          ])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}